
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/mobile/broadband",
      function () {
        return require("private-next-pages/shop/mobile/broadband/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/mobile/broadband"])
      });
    }
  